import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  remove(event) {
    event.preventDefault();
    console.log("Botón eliminar presionado");
    const fila = event.target.closest("tr");
    if (fila) fila.remove();
  }
}
